import React, { useEffect, useRef, useState } from "react";
import { hideModal, showModal } from "../../utils/modalUtility";
import useAxios from "../../utils/useAxios";
import * as XLSX from "xlsx";
import { useAppContext } from "../../context/AppContext";

const GiftDistribution = () => {
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [role, setRole] = useState(null);
  const [masterGifts, setMasterGifts] = useState([]);
  const [masterOccasions, setMasterOccasions] = useState([]);
  const [giftDistribution, setGiftDistribution] = useState([]);
  const [selectedDistribution, setSelectedDistribution] = useState(null);
  const [currentGiftDistributionId, setCurrentGiftDistributionId] =
    useState(null);

  const [deliverLoadingId, setDeliverLoadingId] = useState(null);
  const [deliveryAssignments, setDeliveryAssignments] = useState({});
  const [currentUser, setCurrentUser] = useState(null);

  // const [donorIds, setDonorIds] = useState([]);
  const [donorData, setDonorData] = useState([]);
  const [markDeliverLoadingId, setMarkDeliverLoadingId] = useState(null);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    gift_name: "",
    occasion: "",
  });

  const axiosAPI = useAxios();
  const { state } = useAppContext();

  async function fetchMasterOccasion() {
    //  setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-occasions`);
      setMasterOccasions(res?.data?.results);
    } catch (err) {
      console.error("Error fetching occasions:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  async function fetchMasterGift() {
    //  setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-gifts`);
      // console.log("Gifts", res.data);
      setMasterGifts(res?.data?.results);
    } catch (err) {
      console.error("Error fetching gifts:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  async function fetchGiftDistribution() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/giftDistribution`);
      setGiftDistribution(response?.data?.data); // Assuming backend returns { data: [...] }
      //   setError("");
    } catch (err) {
      console.error("Error fetching donor gifts:", err);
      //   setError("Failed to fetch gifts.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchGiftDistributionById(id) {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/giftDistribution/${id}`);
      setSelectedDistribution(response?.data?.data?.users); // Assuming backend returns { data: [...] }
      //   setError("");
      showModal("giftDistributionModalById");
    } catch (err) {
      console.error("Error fetching donor gifts:", err);
      //   setError("Failed to fetch gifts.");
    } finally {
      setLoading(false);
    }
  }

  function removeFormData() {
    setFormData({
      gift_name: "",
      occasion: "",
    });
    setDonorData([]);
    //  Clear the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  }

  const openAddModal = () => {
    showModal("giftModal");
  };

  const closeModal = () => {
    removeFormData();
  };

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle Excel/CSV upload
  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const isCSV = file.name.endsWith(".csv");

    reader.onload = (event) => {
      const data = event.target.result;

      try {
        let workbook, worksheet, jsonData;

        if (isCSV) {
          workbook = XLSX.read(data, { type: "binary" });
          worksheet = workbook.Sheets[workbook.SheetNames[0]];
        } else {
          workbook = XLSX.read(new Uint8Array(data), { type: "array" });
          worksheet = workbook.Sheets[workbook.SheetNames[0]];
        }

        jsonData = XLSX.utils.sheet_to_json(worksheet);

        console.log("json Data", jsonData);

        // Assuming your sheet has a column named `donor_id`
        // const ids = jsonData.map((row) => row.donor_id).filter(Boolean);

        const donors = jsonData
          .map((row) => {
            const donor_id = row.donor_id || ""; // empty string if missing
            const address = row.address || ""; // empty string if missing
            const zipcode = row.zipcode || ""; // empty string if missing

            // Only include rows that have a donor_id
            if (donor_id) return { donor_id, address, zipcode };
            return null;
          })
          .filter(Boolean);

        // console.log("Donors", donors);

        // setDonorIds(ids);
        // setDonorIds(donors)

        setDonorData(donors);
      } catch (error) {
        console.error("Error parsing file:", error);
      }
    };

    if (isCSV) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalPayload = {
      ...formData,
      donor_data: donorData,
    };

    removeFormData();

    console.log("Payload to send:", finalPayload);

    // return;

    try {
      let response = await axiosAPI.post(`/api/giftDistribution`, finalPayload);
      window.notifyMessage("Success", "Gift Added successfully", "success");
      hideModal("giftModal");
      removeFormData();
      fetchGiftDistribution();
      //   resetForm();
      //   setAddGiftLoading(false);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  const handleDeliver = async (gift) => {
    const payload = {
      gift_distribution_id: currentGiftDistributionId,
      receiver_id: gift.id,
    };

    setDeliverLoadingId(gift.id);

    try {
      const response = await axiosAPI.post(
        `/api/giftDistributionAssignment`,
        payload
      );

      window.notifyMessage(
        "Success",
        "Gift Assignment Added successfully",
        "success"
      );

      //  Mark as self-assigned
      setDeliveryAssignments((prev) => ({
        ...prev,
        [gift.id]: { type: "self", name: currentUser }, // get from context or props
      }));
      fetchGiftDistributionById(currentGiftDistributionId);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");

        //  Check if already assigned by someone else
        const deliveredBy = error.response.data.delivered_by;

        if (deliveredBy) {
          setDeliveryAssignments((prev) => ({
            ...prev,
            [gift.id]: { type: "other", name: deliveredBy },
          }));
        }
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    } finally {
      setDeliverLoadingId(null);
    }
  };

  // console.log("Delivery assignment", deliveryAssignments);

  async function handleMarkAsDelivered(gift) {
    // console.log("gift", gift);

    const payload = {
      receiver_id: gift.id,
      current_gift_distribution_id: currentGiftDistributionId,
    };

    // console.log("payload", payload);

    try {
      const response = await axiosAPI.put(
        "/api/giftDistributionAssignment",
        payload
      );

      window.notifyMessage(
        "Success",
        "Marked as delivered successfully!",
        "success"
      );

      // Optional: Refresh data or close modal
      // await fetchGiftDistributionDetails(); // if you have a fetch function
      // hideModal("giftDistributionModalById");
      fetchGiftDistributionById(currentGiftDistributionId);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage(
          "Error",
          "An unexpected error occurred!",
          "danger"
        );
      }
    }
  }

  function openEditModal(current_gift_distibution_id) {
    setCurrentGiftDistributionId(current_gift_distibution_id);
    fetchGiftDistributionById(current_gift_distibution_id);
  }

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    // const current_user = JSON.parse(localStorage.getItem("full_name")); // Parses string "admin" to plain string
    // setRole(role);
    setRole(state?.user?.role);
    setCurrentUser(state?.user?.full_name);
  }, []);

  useEffect(() => {
    fetchMasterGift();
    fetchMasterOccasion();
    fetchGiftDistribution();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-4">
          {role === "admin" && (
            <button
              type="button"
              className="btn btn-dark btn-round"
              onClick={() => openAddModal()}
            >
              Add Gifts Distrbution
            </button>
          )}
        </div>

        {/* Gift Distribution Modal */}
        <div
          className="modal fade "
          id="giftModal"
          tabIndex="-1"
          aria-labelledby="giftModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content border">
              <div className="modal-header">
                <h5 className="modal-title" id="giftModalLabel">
                  {isEditMode
                    ? "Edit Gift Distribution"
                    : "Add Gift Distribution"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  //   onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body shadow">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="gift_name" className="form-label">
                      Gift Name
                    </label>

                    <select
                      className="form-select"
                      id="gift_name"
                      name="gift_name"
                      value={formData.gift_name}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        -- Select an gift --
                      </option>
                      {masterGifts?.map((item) => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="occasion" className="form-label">
                      Occasion
                    </label>

                    <select
                      className="form-select"
                      id="occasion"
                      name="occasion"
                      value={formData.occasion}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        -- Select an occasion --
                      </option>
                      {masterOccasions?.map((item) => (
                        <option key={item.id} value={item.occasion_name}>
                          {item.occasion_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="donor_file" className="form-label">
                      Upload Donor ID Excel File
                    </label>

                    <input
                      type="file"
                      className="form-control"
                      id="donor_file"
                      ref={fileInputRef}
                      accept=".xlsx, .xls, .csv"
                      onChange={handleExcelUpload}
                      required
                    />
                  </div>
                  <div className="mt-3 mb-3">
                    <button
                      type="button"
                      className="btn btn-link p-0 text-primary"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = "/samples/Donor ids.xlsx";
                        link.download = "Donor ids.xlsx";
                        link.click();
                      }}
                    >
                      Download Sample Sheet
                    </button>
                  </div>
                  <strong>Note:</strong> Donor id must be one of the following:
                  <br />
                  <div className="mt-2 d-flex justify-content-start">
                    <span className="badge rounded-pill bg-secondary mb-2 text-dark me-1">
                      donor_id
                    </span>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode
                      ? "Update Gift Distribution"
                      : "Add Gift Distribution"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Gift Distribution Modal By Id */}
        <div
          className="modal fade"
          id="giftDistributionModalById"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Gift Distribution Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  //   onClick={closeModal}
                />
              </div>
              <div className="modal-body ">
                {selectedDistribution && selectedDistribution.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                      <thead className="table-dark">
                        <tr>
                          <th>#</th>
                          <th>Donor ID</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>zip code</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDistribution.map((gift, index) => (
                          <tr key={gift.id || index}>
                            <td>{index + 1}</td>
                            <td>{gift.donor_id}</td>
                            <td>{gift.full_name}</td>
                            <td>{gift.phone_number}</td>
                            <td>{gift.zip_code}</td>
                            <td key={gift.id || index}>
                              {gift.is_assigned ? (
                                gift.assignment_status === "PICKUP" ? (
                                  <div className="d-flex gap-2 align-items-center">
                                    {gift.assigned_by_me === "no" && (
                                      <p className="text-muted small mb-0 fw-semibold">
                                        🚚 Delivering by{" "}
                                        {gift?.assigned_by_name}
                                      </p>
                                    )}

                                    {gift.assigned_by_me === "yes" && (
                                      <button
                                        className="btn btn-sm btn-success"
                                        onClick={() =>
                                          handleMarkAsDelivered(gift)
                                        }
                                      >
                                        Mark as Delivered
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <p className="text-muted small mb-0 fw-semibold">
                                    Delivered by {gift.assigned_by_name}
                                  </p>
                                )
                              ) : deliveryAssignments[gift.id] ? (
                                <p className="text-muted small mb-0 fw-semibold">
                                  🚚 Delivering by{" "}
                                  {deliveryAssignments[gift.id].name}
                                </p>
                              ) : (
                                <button
                                  className="btn btn-sm btn-dark"
                                  onClick={() => handleDeliver(gift)}
                                  disabled={deliverLoadingId === gift.id}
                                >
                                  {deliverLoadingId === gift.id ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      Delivering...
                                    </>
                                  ) : (
                                    "I will deliver"
                                  )}
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted">No records available.</p>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Gifts Distribution Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* Title */}
                <h4 className="card-title mb-0">
                  All Gifts Distribution ({giftDistribution?.length})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>SR No</th>
                        <th>Gift Name</th>
                        <th>Ocassion</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : giftDistribution.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        giftDistribution.map((gifts, index) => {
                          const formattedDate = new Date(
                            gifts.created_at
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={gifts.id}>
                              <td>{index + 1}</td>
                              <td>{gifts.gift_name}</td>
                              <td>{gifts.occasion}</td>
                              <td>{formattedDate}</td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(gifts.id)}
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                                {/* <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(gifts.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button> */}
                                {/* {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                    onClick={() => handleDelete(gifts.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )} */}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftDistribution;
